import { AllianceModule } from 'src/app/modules/alliance/alliance.module';
import { ConfigAlliance } from 'src/app/modules/alliance/config/config';

export const facilityModule = AllianceModule;

export const configFacility = ConfigAlliance;
